module.exports = __webpack_public_path__ + "static/media/Portrait-10022.f7887ce0.jpg";